import { useContext, useState, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI"
import UI_Button from "./UI_Button";
import UI_Icon from "./UI_Icons";

function pad(n) {
    return String(n).padStart(2, "0");
}

function getNowFormatted(inputType) {
    const d = new Date();
    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());

    switch (inputType) {
        case "date":
            // YYYY-MM-DD
            return `${year}-${month}-${day}`;
        case "time":
            // HH:MM (you can add :SS if you want seconds)
            return `${hours}:${minutes}`;
        case "datetime-local":
            // YYYY-MM-DDTHH:MM
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        default:
            return "";
    }
}

export default function UI_Password_List({
    id,
    Input_Type = "text",
    Input_Placeholder,
    Label_Text,
    onInput,
    onSubmit,
    onKeyDown,
    Value,
    Value_Set_Enable,
    onChange,
    onBlur,
    onClick,
    autoFocus,
    onFocus,
    disabled,
    Classes,
    min,
    max,
    PreventPast,
    Required,
    name
}) {
    const UI = useContext(Context_UI);


    // internal state for controlled mode
    const [Value_Internal, Value_Internal_Set] = useState(() => {
        // prefer provided Value when present; else use current date/time for date/time/datetime-local
        if (Value_Set_Enable) {
            if (Value !== undefined && Value !== null && Value !== "") return Value;
            if (["date", "datetime-local"].includes(Input_Type)) {
                return getNowFormatted(Input_Type);
            }
            return Value || "";
        }
        return ""; // uncontrolled mode uses defaultValue instead
    });
    const [ShowPassword, ShowPassword_Set] = useState(false);

    // sync external Value -> internal when controlled
    useEffect(() => {
        if (!Value_Set_Enable) return;
        if (Value !== undefined && Value !== null && Value !== "") {
            Value_Internal_Set(Value);
        } else if (["date", "datetime-local"].includes(Input_Type)) {
            // If parent intentionally provides empty/undefined value, set current time as fallback
            Value_Internal_Set(getNowFormatted(Input_Type));
        } else {
            Value_Internal_Set(Value || "");
        }
    }, [Value, Value_Set_Enable, Input_Type]);

    const Handle_Input_Change = (e) => {
        const Value_New = e.target.value;
        if (Value_Set_Enable) {
            // controlled input: update internal state
            Value_Internal_Set(Value_New);
        }
        if (onChange) onChange(e);
    };

    const Handle_Input = (e) => {
        if (onChange) {
            onChange(e);
        }
        if (onInput) {
            onInput(e);
        }
    }

    // label htmlFor fix
    return (
        <>
            <p className="General_Paragraph">
                Your password must have:
            </p>
            <div className="Input_Password_List" id={id} Length="Fail" Upper="Fail" Lower="Fail" Number="Fail" Special="Fail">
                <div className="Input_Password_List_Item" id={`${id}_Length`} Type="Length">
                    <UI_Icon Name="Cross" className="Input_Password_List_Item_Fail" />
                    <UI_Icon Name="Check" className="Input_Password_List_Item_Pass" />
                    <p className="General_Paragraph">
                        At least 8 characters
                    </p>
                </div>


                <div className="Input_Password_List_Item" id={`${id}_Upper`} Type="Upper" >
                    <UI_Icon Name="Cross" className="Input_Password_List_Item_Fail" />
                    <UI_Icon Name="Check" className="Input_Password_List_Item_Pass" />
                    <p className="General_Paragraph">
                        At least 1 uppercase letter
                    </p>
                </div>

                <div className="Input_Password_List_Item" id={`${id}_Lower`} Type="Lower" >
                    <UI_Icon Name="Cross" className="Input_Password_List_Item_Fail" />
                    <UI_Icon Name="Check" className="Input_Password_List_Item_Pass" />
                    <p className="General_Paragraph">
                        At least 1 lowercase letter
                    </p>
                </div>

                <div className="Input_Password_List_Item" Type="Number" id={`${id}_Number`} >
                    <UI_Icon Name="Cross" className="Input_Password_List_Item_Fail" />
                    <UI_Icon Name="Check" className="Input_Password_List_Item_Pass" />
                    <p className="General_Paragraph">
                        At least 1 number
                    </p>
                </div>

                <div className="Input_Password_List_Item" Type="Special" id={`${id}_Special`} >
                    <UI_Icon Name="Cross" className="Input_Password_List_Item_Fail" />
                    <UI_Icon Name="Check" className="Input_Password_List_Item_Pass" />
                    <p className="General_Paragraph">
                        At least 1 special character (!@#$%^&*)
                    </p>
                </div>

            </div>
        </>

    );
}
